/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from 'react';
import EditableText from './EditableText';
import Attributes from './model/Attributes';

interface StatAttributeMm2024Props {
  label: string;
  attrClass: string;
  modClass: string;
  value: number;
  savingThrow: number;
  onUpdate: (newValue: number) => void;
  onToggleSavingThrow: () => void;
}

const StatAttributeMm2024: React.FC<StatAttributeMm2024Props> = ({ label, attrClass, modClass, value, savingThrow, onUpdate, onToggleSavingThrow }) => {
  return (
    <tr className={attrClass}>
      <th>
        {label}
      </th>
      <td>
        <EditableText
              type="number"
              min={1}
              max={30}
              width="30px"
              initialValue={value}
              onSave={(newValue: string | number) => onUpdate(Math.max(0, parseInt(newValue as string, 10)))}
        />
      </td>
      <td className={modClass}>
        {(value > 9 ? "+" : "")}{Attributes.getBonus(value)}
      </td>
      <td className={modClass}><span className={'edit-field ' + modClass} style={{padding: '3px'}} onClick={onToggleSavingThrow}>{savingThrow >= 0 ? '+' : ''}{savingThrow}</span></td>
    </tr>
  );
};

export default StatAttributeMm2024;
